import { render } from "./Fail.vue?vue&type=template&id=04a25268&scoped=true"
import script from "./Fail.vue?vue&type=script&lang=js"
export * from "./Fail.vue?vue&type=script&lang=js"

import "./Fail.vue?vue&type=style&index=0&id=04a25268&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a25268"]])

export default __exports__